import { Component, OnInit, OnDestroy } from "@angular/core";
import { DocumentoObraService } from "src/app/services/documento-obra.service";
import { DocumentoObra } from "src/app/models/entities/documento-obra";
import { take, switchMap, map } from "rxjs/operators";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { LoaderService } from "src/app/services/loader.service";
import { AngularFireStorage } from "@angular/fire/storage";
import { Subscription } from "rxjs";
import { convertToR3QueryMetadata } from "@angular/core/src/render3/jit/directive";
import { Obra } from "../../../../models/entities/obra";
import { ObraService } from "../../../../services/obra.service";

interface DocumentoObraDTO {
  levantamiento: LevantamientoObra;
  documento: Obra;
}

@Component({
  selector: "buscador-archivos-obras",
  templateUrl: "./buscador-archivos-obras.component.html",
  styleUrls: ["./buscador-archivos-obras.component.scss"],
})
export class BuscadorArchivosObrasComponent implements OnInit, OnDestroy {
  public numeroCoincidencias: number = 0;
  public documentosObras: DocumentoObraDTO[] = [];
  public documentosObrasFiltrados: DocumentoObraDTO[] = [];
  public suscripcionDocumentos: Subscription;
  public suscripcionDescargaDocumento: Subscription;
  constructor(
    private loader: LoaderService,
    private documentoObraService: DocumentoObraService,
    private levantamientoObraService: LevantamientoObraService,
    private storage: AngularFireStorage,
    private obraService: ObraService
  ) {
    this.loader.activarLoaderScreen();
  }

  ngOnInit() {
    this.buscarObrasConDocumentos();
  }

  public buscarObrasConDocumentos() {
    this.obraService
      .findAll()
      .pipe(
        take(1),
        switchMap((documentos: Obra[]) =>
          this.levantamientoObraService.findAll().pipe(
            take(1),
            map((levantamientos: LevantamientoObra[]) => {
              return documentos.map((documento: Obra) => {
                let documentoObraDTO: DocumentoObraDTO = {
                  documento,
                  levantamiento: levantamientos.find(
                    (l: LevantamientoObra) =>
                      l.key === documento.keyLevantamientoObra
                  ),
                };
                return documentoObraDTO;
              });
            })
          )
        )
      )
      .subscribe((respuesta: DocumentoObraDTO[]) => {
        this.documentosObras = respuesta;
        // console.log(respuesta);
        //MARIOO: ERROR nombreObra: undefined , ES POR QUE SE ELIMINAN LAS levantamientoObras/  Y SE QUEDAN LOS documentosObras/
        //eliminando todos los undefined del siguiente console convertToR3QueryMetadata.
        // console.log(respuesta);
        // this.eliminarArchivosBasura(respuesta);
        this.loader.desactivarLoaderScreen();
      });
  }

  eliminarArchivosBasura(documentosObras: any) {
    const buscandoUndefined = [];
    documentosObras.map((obra) => {
      if (obra.levantamiento === undefined) {
        buscandoUndefined.push(obra);
      }
    });
    // console.log(buscandoUndefined);
    if (buscandoUndefined.length > 0) {
      buscandoUndefined.forEach((obra) => {
        this.documentoObraService
          .delete(obra.documento.key)
          .then(() => console.log("Documento eliminado!"))
          .catch(() => console.log("No se pudo eliminar el documento!"));
      });
    }
  }

  public buscarCoincidencias(event: any) {
    let texto: string = event.target.value;

    this.documentosObrasFiltrados = this.documentosObras.filter(
      (d: DocumentoObraDTO) =>
        d.levantamiento.nombreObra.toLowerCase().includes(texto.toLowerCase())
    );
    //this.documentosObrasFiltrados = this.documentosObras;
    this.numeroCoincidencias = this.documentosObrasFiltrados.length;
    // console.log(this.documentosObrasFiltrados);
  }

  async descargarFichaTecnica(keyLevantamiento: string) {
    //MARIOO:  SECAMBIO rutaStorage x urlDescarga en el html
    //async descargarFichaTecnica(rutaStorage: string) {
    // this.loader.activarLoaderScreen('Descargando ficha técnica');
    //const ref = this.storage.ref(rutaStorage);
    //this.suscripcionDescargaDocumento = ref.getDownloadURL().pipe(take(1)).subscribe(async (urlDescarga: string) => {
    //window.open(urlDescarga, "_blank");
    // window.location.href = urlDescarga ;
    // window.open(urlDescarga, "_blank");
    window.open(
      `https://198.37.117.136/2021/ficha2021.aspx?keyLevantamiento=${keyLevantamiento}`,
      "_blank"
    );

    //});
  }

  public toDataURL(url) {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  }

  ngOnDestroy(): void {
    if (this.suscripcionDocumentos) {
      this.suscripcionDocumentos.unsubscribe();
    }
    if (this.suscripcionDescargaDocumento) {
      this.suscripcionDescargaDocumento.unsubscribe();
    }
  }
}
